import queryString from 'query-string';

export const getCustomerIDFromURL = () => {
  const parsedSearch = queryString.parse(window.location.search, {
    arrayFormat: 'comma',
  });

  return parsedSearch.customerID || null;
};
